/* eslint-disable */

import $ from "jquery";
window.$ = $;
window.jQuery = $;

import "node_modules/angular-material/angular-material.scss";
import "normalize.css";
import "animate.css";
import "node_modules/angular-material-data-table/dist/md-data-table.css";
import "node_modules/material-icons/iconfont/material-icons.css";
// In the bundle: the server does not serve node_modules, a <link> to it gets index.html instead
import "node_modules/angularjs-color-picker/dist/angularjs-color-picker.min.css";


import angular          from "angular";

import moment           from "moment-timezone";

window.moment = moment;

//import "angular-ui-bootstrap";

import "angular-material";
import "angular-messages";

import ngCookies        from "angular-cookies";
import ngSanitize       from "angular-sanitize";
import uiRouter         from "angular-ui-router";
import uiRouterTitle    from "angular-ui-router-title";
import stateHelper      from "angular-ui-router.statehelper";
import angularUiSwitch  from "angular-ui-switch";
import ngNotify         from "ng-notify";
import select           from "ui-select";
import vcRecaptcha      from "angular-recaptcha";
import gettext          from "angular-gettext";
import ngResource       from "./services/angular-resource";
import picker from "angularjs-color-picker";
import dndLists from "angular-drag-and-drop-lists";
import "angular-material-data-table";
import "angular-wizard";
import "ng-material-datetimepicker";


import "angular-fixed-table-header"

import '../locale/pl.po';


// WEBPACK FOOTER //
// ./sources/vendor.js